(function () {
  "use strict";

  if (!window.DNB) {
    return;
  }

  window.DNB.register(function () {
    var timeEl = document.querySelector("[data-local-time]");
    if (timeEl) {
      var formatter = new Intl.DateTimeFormat("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
      });
      timeEl.textContent = formatter.format(new Date());
    }

    var brand = document.querySelector(".site-footer__brand");
    if (brand) {
      var brandText = (brand.getAttribute("data-text") || brand.textContent || "").trim();
      if (brandText) {
        brand.textContent = brandText;
        brand.setAttribute("aria-label", brandText);

        var canAnimate = window.ScrollTrigger && window.Splitting;

        if (canAnimate && brand.dataset.flipReady !== "true") {
          brand.dataset.flipReady = "true";
          if (!brand.hasAttribute("data-splitting")) {
            brand.setAttribute("data-splitting", "chars");
          }
          brand.classList.add("text--flipping");

          window.Splitting({ target: brand, by: "chars" });

          var words = brand.querySelectorAll(".word");
          var setScrollState = function (state) {
            brand.setAttribute("data-scroll", state);
            for (var i = 0; i < words.length; i++) {
              words[i].setAttribute("data-scroll", state);
            }
          };

          setScrollState("out");

          var triggerOptions = {
            trigger: brand,
            start: "top 80%",
            end: "bottom 20%",
            invalidateOnRefresh: true,
            onEnter: function () {
              setScrollState("in");
            },
            onEnterBack: function () {
              setScrollState("in");
            },
            onLeave: function () {
              setScrollState("out");
            },
            onLeaveBack: function () {
              setScrollState("out");
            }
          };

          if (window.DNB.scroller) {
            triggerOptions.scroller = window.DNB.scroller;
          }

          window.ScrollTrigger.create(triggerOptions);
        }
      }
    }

    var banner = document.querySelector(".cookie-banner");
    var action = document.querySelector(".cookie-banner__action");
    if (banner && action) {
      var stored = window.localStorage.getItem("dnb-cookie-consent");
      if (stored === "accepted") {
        banner.classList.add("is-hidden");
      } else {
        banner.classList.remove("is-hidden");
        action.addEventListener("click", function () {
          banner.classList.add("is-hidden");
          window.localStorage.setItem("dnb-cookie-consent", "accepted");
        });
      }
    }

    var topLink = document.querySelector("[data-scroll-top]");
    if (topLink) {
      topLink.addEventListener("click", function (event) {
        event.preventDefault();
        if (window.DNB && window.DNB.locoScroll) {
          window.DNB.locoScroll.scrollTo(0, { duration: 1, disableLerp: true });
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      });
    }

    var newsletterForm = document.querySelector(".site-footer__form");
    if (newsletterForm) {
      var emailInput = newsletterForm.querySelector('input[type="email"]');
      var field = newsletterForm.querySelector(".site-footer__field");
      var submitBtn = newsletterForm.querySelector(".site-footer__submit");
      var originalSubmitHTML = submitBtn ? submitBtn.innerHTML : "";
      var alertModal = null;
      var alertPanel = null;
      var alertTitle = null;
      var alertMessage = null;
      var alertLastFocus = null;

      var readMessage = function (id, fallback) {
        var element = document.getElementById(id);
        if (element && element.value) {
          return element.value;
        }
        return fallback;
      };

      var requiredMessage = readMessage("newsletter-email-required-message", "");
      var invalidMessage = readMessage("newsletter-email-invalid-message", "");
      var successTitle = readMessage("subscribe-newsletter-success-title", "");
      var successMessage = readMessage("subscribe-newsletter-success-message", "");
      var errorTitle = readMessage("global-form-error-title", "");
      var errorMessage = readMessage("global-form-error-message", "");

      if (!emailInput) {
        return;
      }

      var ensureAlertModal = function () {
        if (alertModal) {
          return;
        }

        alertModal = document.querySelector("[data-newsletter-alert-modal]");
        if (!alertModal) {
          alertModal = document.createElement("div");
          alertModal.className = "apply-modal apply-alert-modal";
          alertModal.setAttribute("data-newsletter-alert-modal", "");
          alertModal.setAttribute("aria-hidden", "true");
          alertModal.innerHTML =
            '<button class="apply-modal__overlay" type="button" data-newsletter-alert-close aria-label="Close"></button>' +
            '<div class="apply-modal__panel apply-alert-modal__panel" role="dialog" aria-modal="true" aria-labelledby="newsletter-alert-title" tabindex="-1">' +
            '<button class="apply-modal__close" type="button" data-newsletter-alert-close aria-label="Close">x</button>' +
            '<div class="apply-alert-modal__inner">' +
            '<p class="apply-alert-modal__title" id="newsletter-alert-title" data-newsletter-alert-title>Notice</p>' +
            '<p class="apply-alert-modal__message" data-newsletter-alert-message></p>' +
            '<div class="apply-alert-modal__actions">' +
            '<button class="btn btn--primary" type="button" data-newsletter-alert-close>CLOSE</button>' +
            "</div>" +
            "</div>" +
            "</div>";
          document.body.appendChild(alertModal);
        }

        alertPanel = alertModal.querySelector(".apply-modal__panel");
        alertTitle = alertModal.querySelector("[data-newsletter-alert-title]");
        alertMessage = alertModal.querySelector("[data-newsletter-alert-message]");

        var closeButtons = alertModal.querySelectorAll("[data-newsletter-alert-close]");
        closeButtons.forEach(function (button) {
          button.addEventListener("click", function () {
            setAlertState(false);
          });
        });
      };

      var setAlertState = function (shouldOpen, options) {
        ensureAlertModal();
        if (!alertModal) {
          return;
        }

        if (shouldOpen) {
          alertLastFocus = document.activeElement;
          if (options && options.title && alertTitle) {
            alertTitle.textContent = options.title;
          }
          if (options && typeof options.message !== "undefined" && alertMessage) {
            alertMessage.textContent = options.message;
          }
          alertModal.classList.add("is-open");
          alertModal.setAttribute("aria-hidden", "false");
          document.body.classList.add("is-modal-open");
          if (alertPanel) {
            alertPanel.focus();
          }
          return;
        }

        alertModal.classList.remove("is-open");
        alertModal.setAttribute("aria-hidden", "true");
        if (!document.querySelector(".apply-modal.is-open, .project-modal.is-open")) {
          document.body.classList.remove("is-modal-open");
        }
        if (alertLastFocus && typeof alertLastFocus.focus === "function") {
          alertLastFocus.focus();
        }
      };

      document.addEventListener("keydown", function (event) {
        if (event.key !== "Escape") {
          return;
        }
        if (alertModal && alertModal.classList.contains("is-open")) {
          setAlertState(false);
        }
      });

      var setFieldError = function (message) {
        if (field) {
          field.classList.add("is-invalid");
          field.setAttribute("data-tooltip", message);
        }
        if (emailInput) {
          emailInput.setAttribute("aria-invalid", "true");
        }
      };

      var clearFieldError = function () {
        if (field) {
          field.classList.remove("is-invalid");
          field.removeAttribute("data-tooltip");
        }
        if (emailInput) {
          emailInput.removeAttribute("aria-invalid");
        }
      };

      var getEmailError = function () {
        if (!emailInput) {
          return null;
        }
        var value = emailInput.value.trim();
        if (!value) {
          return requiredMessage;
        }
        if (!emailInput.checkValidity()) {
          return invalidMessage;
        }
        return null;
      };

      var showNewsletterMessage = function (title, message) {
        setAlertState(true, { title: title, message: message });
      };

      if (emailInput) {
        emailInput.addEventListener("invalid", function (event) {
          event.preventDefault();
        });

        emailInput.addEventListener("input", function () {
          if (!field || !field.classList.contains("is-invalid")) {
            return;
          }
          var error = getEmailError();
          if (error) {
            setFieldError(error);
          } else {
            clearFieldError();
          }
        });

        emailInput.addEventListener("blur", function () {
          var error = getEmailError();
          if (error) {
            setFieldError(error);
          } else {
            clearFieldError();
          }
        });
      }

      document.addEventListener("click", function (event) {
        var target = event.target;
        if (!target || !field || !field.classList.contains("is-invalid")) {
          return;
        }
        if (target === emailInput || (submitBtn && submitBtn.contains(target))) {
          return;
        }
        clearFieldError();
      });

      newsletterForm.addEventListener("submit", function (event) {
        event.preventDefault();
        var error = getEmailError();
        if (error) {
          setFieldError(error);
          if (emailInput) {
            emailInput.focus();
          }
          return;
        }

        clearFieldError();

        if (submitBtn) {
          submitBtn.disabled = true;
        }

        var emailValue = emailInput ? emailInput.value.trim() : "";
        var finalize = function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            if (typeof originalSubmitHTML === "string") {
              submitBtn.innerHTML = originalSubmitHTML;
            }
          }
        };

        var handleSuccess = function (response) {
          if (response && response.success) {
            showNewsletterMessage(successTitle, successMessage);
            if (emailInput) {
              emailInput.value = "";
            }
          } else {
            showNewsletterMessage(errorTitle, errorMessage);
          }
        };

        var handleError = function () {
          showNewsletterMessage(errorTitle, errorMessage);
        };

        if (window.jQuery && window.jQuery.ajax) {
          window.jQuery.ajax({
            url: "/subscribe-newsletter",
            type: "POST",
            data: { email: emailValue },
            success: function (response) {
              handleSuccess(response);
            },
            error: function () {
              handleError();
            },
            complete: function () {
              finalize();
            }
          });
          return;
        }

        fetch("/subscribe-newsletter", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
          },
          body: new URLSearchParams({ email: emailValue })
        })
          .then(function (response) {
            return response
              .json()
              .then(function (data) {
                return { ok: response.ok, data: data };
              })
              .catch(function () {
                return { ok: response.ok, data: null };
              });
          })
          .then(function (result) {
            handleSuccess(result.data);
          })
          .catch(function () {
            handleError();
          })
          .finally(function () {
            finalize();
          });
      });
    }
  });
})();
